import axios from '../http/axios';
import { PORTAL_SERVICOS_BACKEND } from '../constants/environment';

export const getSolicitacoes = (status) =>
  axios.get(
    `${PORTAL_SERVICOS_BACKEND}/frontend/solicitacoes?status=${status}`
  );

export const getSolicitacao = (codigo) =>
  axios.get(
    `${PORTAL_SERVICOS_BACKEND}/frontend/solicitacoes/${codigo}`
  );
